import React, { PureComponent } from 'react';

import OneVisualLayout from '../layouts/one-visual';

import Image from '../../../../containers/assets/instructor-performance-feedback-thats-all.png'

class ThatsAll extends PureComponent {

  render() {
    return (
      <OneVisualLayout
        section="That’s All!"
        title="See You in the Next Round"
        paragraph1={(
          <p>That’s all for now! You can check this performance feedback again at any time in the game under the Results section.</p>
        )}
        visual={(
          <img src={Image} alt='Rocket' />
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    );
  }
}

export default ThatsAll;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/thats-all.js